import { ProjectProps } from "@/interfaces/project_types";

export function ProjectProgressHeader({ project }: { project: ProjectProps; }) {
    return (
        <div className="flex justify-between items-center mb-1">
            <p className="font-semibold">Project Progress</p>
            <p className="text-left text-sm">{project.task_progress?.percent_complete.toFixed(1)}% Complete</p>
        </div>
    );
}
